export default __webpack_public_path__ + "static/media/Background_00282.22093afd.png";